// Routes.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from '../pages/Navbar/Navbar';
import Tenders from '../pages/Tenders/Tenders'
import SignUp from '../pages/SignUp/SignUp'
import CloseTenders from '../pages/CLoseTenders/CloseTenders';
const AppRoute = () => {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Tenders />} />
        <Route path="/close_tenders" element={<CloseTenders />} />
        <Route path="/sign_up" element={<SignUp />} />

      </Routes>
    </Router>
  );
};

export default AppRoute;
